import React, { } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../../Store"
import { useApolloClient } from "@apollo/client";
import { MUTATE_STATION_CONFIG, StationConfig, UpsertStationConfigsRepsonse } from "./queryStationConfigs";
import { upsertStationConfig } from "./stationConfigSlice";

export type MutateStationConfigPayload = { stationId: number, valueType: number, value: number, valueMin?: number, valueMax?: number }
export const useStationConfig = () => {
  const dispatch = useAppDispatch();
  const domain = useAppSelector((state: RootState) => state.activeData?.farm);
  const client = useApolloClient();

  const mutateConfig =  async (configs: MutateStationConfigPayload[]): Promise<boolean> => {
    
    try {
      const result = await client.mutate<UpsertStationConfigsRepsonse>({ mutation: MUTATE_STATION_CONFIG, variables: { domain, configs } });

      if (result.data && result.data.station.upsertStationConfigs.updatedValues) {
        dispatch(upsertStationConfig(result.data.station.upsertStationConfigs.updatedValues));
      }

      return result.data?.station.upsertStationConfigs.success ?? false;
    } catch (error) {
      console.log(error);
      return false;
    }

  }

  return {mutateConfig}
}